module.exports = __webpack_public_path__ + "img/chart2.ea4b8d69.png";